/**
 * AddShowCtrl controller
 * Add/edit TV Show
 */

import moment from 'moment'
import {
  PLATFORM_TYPES, RESOLUTIONS,
  TAG_CUSTOM_ERROR_TYPES,
  TV_SHOW_IMAGES_TYPE, URL_PATTERN
} from 'app/core/constants'
import { getId, remove } from 'app/helpers/entity'
import { formatDateByTimezone } from '../../app/helpers/date'
import { openAssignContentSets } from '../common/directives/contentItems/ci.directives'

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

// controller mixins
AddShowCtrl.mixes = [
  ['onOffCtrlMixin'],
  ['m2mCtrlMixin', 'show', 'networks'],
  ['m2mCtrlMixin', 'show', 'categories'],
  ['m2mCtrlMixin', 'show', 'tags']
]

/**
 * AddShowCtrl controller
 *
 * @class AddShowCtrl
 * @memberof mwApp/shows
 * @see mwApp/shows
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/shows.controller:AddShowCtrl
 */
/* @ngInject */
export default function AddShowCtrl (
  $timeout,
  $http,
  $location,
  $scope,
  $state,
  $uibModal,
  Episode,
  Season,
  SeasonEpisode,
  Show,
  ShowSet,
  acls,
  alertLiteSvc,
  alertSvc,
  authSvc,
  networks,
  playbacks,
  show,
  storageSvc
) {
  var vm = this

  vm.urlPattern = URL_PATTERN
  vm.resolutions = RESOLUTIONS

  $scope.loading = false

  vm.activeTab = +$location.hash().trim().slice(1) || 0

  $scope.$watch('vm.activeTab', (n) => {
    if (Number.isInteger(n) && n) {
      $location.hash(`s${n}`)
    }
  })

  vm.getRating = function () {
    if (vm.show.$ageRatingType === 'default') {
      return vm.ageRatings.defaultAgeRatings
    } else {
      if (vm.show.$country) {
        return vm.ageRatings.customAgeRatings.find(r => { return r.id === vm.show.$country.id }).ageRatings
      }
    }
  }

  vm.newEpisodePosition = 'BOTTOM'

  /**
   * TV Show
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   * @type {models.Show}
   */
  vm.show = show

  /**
   * isNew flag
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   * @type {Boolean}
   */
  vm.isNew = show._isNew()

  vm.newEpisodePosition = 'BOTTOM'

  if (!vm.isNew && show.networks.length === 0) {
    vm.networkSelected = { id: 0, name: 'All Organizations' }
  }

  vm.ageRatings = JSON.parse(storageSvc.local.get('ageRatings'))
  vm.countries = JSON.parse(storageSvc.local.get('countries'))

  if (!vm.isNew && show.ageRating) {
    if (vm.show.$ageRatingType === 'default') {
      vm.show.$defaultAgeRating = vm.ageRatings.defaultAgeRatings.find(r => r.id === show.$defaultAgeRating.id)
      vm.show.ageRating = null
    } else {
      vm.show.$country = vm.countries.find(c => c.id === show.$country.id)
      const country = vm.ageRatings.customAgeRatings.find(c => c.id === show.$country.id)
      vm.show.ageRating = country.ageRatings.find(r => r.id === vm.show.ageRating.id)
      vm.show.$defaultAgeRating = null
    }
  }

  /**
   * Networks
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.networks = []
  vm.tagSelected = []
  vm.tagSelected = vm.show.tags
  vm.currentTag = { search: '' }
  vm.tags = null

  /**
   * Playback token generators
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.playbackTokenGenerators = []

  /**
   * TV show seasons
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.seasons = []

  /**
   * TV show episodes
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.episodes = []

  /**
   * Custom error for tag field
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   * @type {Array}
   */
  vm.tagErrors = []

  /**
   * Images types for TV Show
   *
   * @memberOf mwApp/shows.controller:AddShowCtrl
   * @type {Object}
   */
  vm.tvShowImageType = TV_SHOW_IMAGES_TYPE

  /**
   * '»' symbol to use on "Category » SubCategory" buttons, instead of &raquo; or »
   *
   * @memberof mwApp/packages.controller:AddShowCtrl
   * @type {String}
   */
  vm.raquoSymbol = ' ' + String.fromCharCode(187) + ' '

  /**
   * Platform types
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   * @type {Object[]}
   */
  vm.platformTypes = angular.copy(PLATFORM_TYPES.filter((p) => {
    return !(!authSvc.hasEnabledFlag('WEB_PLATFORM_ENABLED') && p.name === 'WEB')
  }))

  /**
   * Table state
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   * @type {Object}
   */
  vm.episodeTableState = {
    pagination: {
      number: 999,
      start: 0,
      totalItemCount: 0
    },
    search: {},
    sort: {
      predicate: 'sortOrder',
      reverse: false
    }
  }

  /**
   * Datepicker settings
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   * @type {Object}
   */
  vm.dpCfg = {
    format: 'yyyy',
    datepickerMode: 'year',
    startingDay: 1,
    minMode: 'year',
    minDate: moment().year(1900).toDate(),
    maxDate: moment().set('year', moment().year() + 5).toDate()
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.openFrom = function () {
    vm.dpCfg.openedFrom = true
  }

  // load extra
  vm.playbackTokenGenerators = playbacks
  vm.listOfNetworks = angular.copy(networks)
  if (!vm.isNew && show.networks.length === 0) {
    show.networks = networks
    vm.networks = [{ id: -1, name: 'Deselect all Organization' }]
  } else {
    const existingNetworks = show.networks.map(getId)
    vm.networks = [{ id: 0, name: 'All Organizations' }].concat(networks.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)))
      .filter(n => existingNetworks.indexOf(n.id) === -1)
  }
  vm.acls = acls

  vm.getSeasons = function () {
    const { id } = show
    Season.loadAll({ tvShow: { id } })
      .to(vm.seasons = [])
      .then((data) => {
        // check episodes
        if (!data.length) {
          vm.getEpisodes()
        } else {
          vm.season = data[0] // set default season
          if (!data.find((d) => d.id === vm.activeTab)) {
            vm.activeTab = vm.seasons.id
            if (vm.seasons.length) {
              vm.newEpisodePosition = vm.seasons?.newEpisodePosition
            }
          }
        }
      })
  }

  // load all season by tv show
  if (!vm.isNew) {
    vm.getSeasons()
  }

  Show._loadExtra()
    .then(result => {
      vm.categories = result.data.payload.filter((categories) => !vm.show.categories.find(c => c.id === categories.id))
    })

  /**
   * Select platform items
   *
   * @param platform
   */
  vm.changeTrailer = (platform) => {
    if (platform.name !== 'STB') {
      const platformIndex = vm.platformTypes.findIndex((p) => p.name === 'STB')
      if (platformIndex !== -1) {
        vm.platformTypes[platformIndex].checked = true
      }
    }
  }

  /**
   * Set tab action for episode
   *
   * @param {Season} season
   */
  vm.setTabCustom = (season) => {
    vm.activeTab = season.id // set active tab to season id

    vm.getSeasonEpisodes()
      .finally(() => {
        vm.season = season // set default season
        vm.newEpisodePosition = season.newEpisodePosition
      })
  }

  vm.getEpisodes = () => {
    const { id } = show

    return Episode.loadSmart(vm.episodeTableState, { tvShow: { id } })
      .then((data) => data.content.map((ep) => {
        ep.tvShow = { id }
        return ep
      }))
      .to(vm.episodes = [])
      .then(data => {
        if (data.length) {
          vm.newEpisodePosition = data[0]?.season.newEpisodePosition
        }
      })
  }

  vm.getSeasonEpisodes = function () {
    const { id } = show

    return SeasonEpisode.loadSmart(vm.episodeTableState, { tvShow: { id }, season: { id: vm.activeTab } })
      .then((data) => data.content.map((ep) => {
        ep.tvShow = { id }
        return ep
      }))
      .to(vm.episodes = [])
  }

  /**
   * Upload logo
   *
   * @param entity
   * @param file
   * @param type
   * @memberof mwApp/shows.controller:AddShowCtrl
   * @function
   */
  function uploadLogo (entity, file, type) {
    return entity._uploadFile(entity._url + '/upload', file, {
      type
    }).data()
  }

  /**
   * Upload Portrait logo
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   * @function
   */
  vm.uploadPortrait = (file, ...args) => {
    const [entity] = args

    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 2
      const heightPart = this.height / 3
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alertError('Vertical poster aspect ratio must be 2:3')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(entity, file, vm.tvShowImageType.PORTRAIT)
        .then((response) => {
          vm.show.$lastUpload = Date.now()
          entity.portraitImageUrl = response.resourceUrl
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
  }

  /**
   * Upload Background logo
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   * @function
   */
  vm.uploadBackground = (file, ...args) => {
    const [entity] = args

    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 16
      const heightPart = this.height / 9
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alertError('Horizontal poster aspect ratio must be 16:9')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(entity, file, vm.tvShowImageType.BACKGROUND)
        .then((response) => {
          entity.backgroundImageUrl = response.resourceUrl
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
  }

  /**
   * Validate, if at least one platform is checked
   *
   * @memberOf mwApp/packages.controller:AddShowCtrl
   */
  vm.atLeastOnePlatform = function () {
    for (var i = vm.platformTypes.length; i--;) {
      if (vm.platformTypes[i].checked) {
        return false
      }
    }
    return true
  }

  /**
   * Create/update TV Show
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.save = function (form) {
    for (const control of form.$$controls) {
      control.$setDirty()
      control.$validate()
    }
    if (!vm.show.publishTime) {
      if (vm.show.$scheduledPublishing) {
        vm.dpCfgShow.changeHandler(form)
      }
    }

    if (form.$invalid) {
      return
    }

    if (vm.tagErrors.length) {
      return
    }
    vm.setDisable()

    show
      ._save((sh) => {
        if (!sh.urls) {
          sh.urls = {}
        }
        if (sh.networks.length === vm.listOfNetworks.length) {
          sh.networks = []
        }
      })
      .then(vm.location(show).reload)
      .then(() => {
        if (vm.isNew && authSvc.hasAccess('editVodSeries')) {
          Show.loadAvailableContentSets(show)
            .then(data => {
              if (data.length) {
                alertSvc.confirm(`${show.name} TV Show has added. <br> Do You want to assign this TV Show to the TV Show Set(s)?`)
                  .then(() => {
                    openAssignContentSets($state, $location, show, true)
                  })
              }
            })
        }
        vm.getSeasons()
      })
      .catch(vm.unsetDisable)
  }

  /**
   * Delete show
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.delete = function () {
    show._delete()
      .then(vm.location(show).list)
  }

  // seasons

  /**
   * Handle open "from" datepicker seasons
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.openPickerSeason = function () {
    vm.dpCfg.openedPickerSeason = true
  }

  /**
   * Add Season (with modal)
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.addSeason = function (season, $event) {
    vm.stopEvent($event)

    const { id } = show
    const isNew = !season
    const initialSeason = angular.copy(season) // initial state
    $uibModal.open({
      templateUrl: 'components/shows/views/addSeason.html',
      controller: 'AddSeasonCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        ss: function () {
          return !isNew
            ? season
            : new Season({ tvShow: { id } })
        },
        show,
        networks: function () {
          return vm.networks
        }
      }
    }).result
      .then(
        function close (season) {
          if (isNew) {
            vm.seasons.push(season)
            vm.seasons.sort((a, b) => {
              return +a.displayNumber - +b.displayNumber
            })
            setTimeout(() => {
              vm.setTabCustom(season)
            }, 100)
          }
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialSeason, season) // restore season
          }
        }
      )
  }

  /**
   * Edit Season
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.editSeason = function (form, season, $event) {
    if (form.$invalid) {
      return
    }
    vm.stopEvent($event)

    season._save(null, `${season._url}`)
      .then(
        () => {
          form.$setPristine()
          season._update()
            .finally(
              () => {
                vm.seasons.sort((a, b) => {
                  return +a.displayNumber - +b.displayNumber
                })
                vm.unsetDisable()
              }
            )
        }
      ).finally(vm.unsetDisable)
  }

  /**
   * Delete Season
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   * @param {models.Season} season
   */
  vm.deleteSeason = function (season) {
    season._delete()
      .then(remove(vm.seasons)(season))
      .finally(() => {
        vm.episodes = []
        vm.season = null
      })
  }

  // episodes

  /**
   * Create/Update episode
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   * @param {models.Episode | models.SeasonEpisode} episode
   * @param $event
   */
  vm.addEpisode = vm.editEpisode = function (episode, $event) {
    vm.stopEvent($event)

    const { id } = show
    const isNew = !episode
    if (!isNew) { // set tv show id
      episode.tvShow = { id }
    }

    const initialEpisode = angular.copy(episode) // initial state
    $uibModal.open({
      templateUrl: 'components/shows/views/addEpisode.html',
      controller: 'AddEpisodeCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        show,
        season: vm.season,
        ep: function () {
          return !isNew
            ? episode._updateCustom()
            : (vm.season
              ? new SeasonEpisode({ tvShow: { id }, season: { id: vm.season.id } })
              : new Episode({ tvShow: { id } }))
        },
        playbackTokenGenerators: () => playbacks,
        extra: function () {
          return vm.season
            ? SeasonEpisode.loadExtra({ id: episode?.id || 0, tvShow: { id }, season: { id: vm.season.id } })
            : Episode.loadExtra({ id: episode?.id || 0, tvShow: { id } })
        },
        networks: () => vm.networks
      }
    }).result
      .then(
        function close (episode) {
          if (isNew) {
            vm.episodes.push(episode)
            // TODO: to sort
          }
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialEpisode, episode) // restore episode
          }
        }
      )
  }

  /**
   * On/Off episode
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   * @param {model.Episode | model.SeasonEpisode} episode
   */
  vm.onOffEpisode = function (episode) {
    return episode._onOff()
  }

  /**
   * Delete episode
   *
   * @memberof mwApp/shows.controller:ShowsCtrl
   * @param {models.Show} episode
   */
  vm.deleteEpisode = function (episode) {
    episode._delete()
      .then(remove(vm.episodes)(episode))
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    link.selected = true
    return list.filter(link => link.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list = list.filter(item => !item.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.dragging = false
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index) {
    items.forEach(item => { item.selected = false })
    const selectedItem = list.find((i) => i.selected)
    const prevIndex = list.findIndex((i) => i.selected)
    list = list
      .slice(0, index)
      .concat(items)
      .concat(list.slice(index))
    list = list.filter(item => !item.selected)
    const sortIndex = list.findIndex((i) => !i.selected && selectedItem.id === i.id)

    if (prevIndex === sortIndex) {
      vm.episodes.forEach(i => { i.selected = false })
      return
    }
    $scope.loading = true

    const n = 2 * (prevIndex > sortIndex) - 1
    const sortOrder = list[sortIndex + n].sortOrder

    selectedItem._order(sortOrder, selectedItem.season ? selectedItem.season.id : null)
      .then(() => {
        selectedItem._updateSmart(vm.episodeTableState)
          .then((data) => data.content)
          .then((data) => data.map((ep) => {
            ep.tvShow = angular.copy(selectedItem.tvShow)
            $scope.loading = false
            return ep
          }))
          .to(vm.episodes = [])
      })

    return true
  }

  /**
   * Move episode to season
   *
   * @memberof mwApp/shows.controller:ShowsCtrl
   * @param {String} seasonId
   * @param {model.Episode} episode
   */
  vm.moveToSeason = function (seasonId, episode) {
    const season = vm.seasons.find((s) => s.id === +seasonId)
    if (season) {
      const sortOrder = season.newEpisodePosition === 'TOP' ? 0 : null
      episode._order(sortOrder, season.id)
        .then(() => {
          episode._updateSmart(vm.episodeTableState)
            .then((data) => data.content)
            .then((content) => content.map((ep) => {
              ep.tvShow = angular.copy(episode.tvShow)
              seasonId = ''
              return ep
            }))
            .to(vm.episodes = [])
            .then(() => {
              alertLiteSvc.alert(`Eisode ${episode.displayNumber} ${episode.title} was moved to Season ${season.displayNumber} ${season.name}`, 'success')
              vm.selectedSeason = null
            })
        })
        .catch(alertLiteSvc.alertError)
    }
  }

  /**
   * Open dropdown and disable others
   *
   * @param o
   * @param list
   */
  $scope.openDropdown = function (o, list) {
    list.forEach((l) => {
      if (l.id !== o.id) {
        l.$toggleDropdown = false
      }
    })
    o.$toggleDropdown = true
  }

  /**
   * Change Publish Now for show
   *
   * @memberof mwApp/show.controller:AddShowCtrl
   */
  vm.handleChangePublishShow = function () {
    if (vm.show.enabled) {
      vm.show.$scheduledPublishing = false
      vm.show.$fromDate = new Date()
      vm.show.$fromTime = new Date()
      vm.show.$toDateUnlimited = true
    }
  }

  /**
   * Change Scheduled Publishing for show
   *
   * @memberof mwApp/show.controller:AddShowCtrl
   */
  vm.handleChangeScheduledShow = function () {
    if (vm.show.$scheduledPublishing) {
      vm.show.enabled = false
    }
  }

  /**
   * Change Publish Now for current season
   *
   * @memberof mwApp/show.controller:AddShowCtrl
   */
  vm.handleChangePublishSeason = function () {
    if (vm.season.enabled) {
      vm.season.$scheduledPublishing = false
      vm.season.$fromDate = new Date()
      vm.season.$toDateUnlimited = true
    }
  }

  /**
   * Change Scheduled Publishing for current season
   *
   * @memberof mwApp/show.controller:AddShowCtrl
   */
  vm.handleChangeScheduledSeason = function () {
    if (vm.season.$scheduledPublishing) {
      vm.season.enabled = false
    }
  }

  /**
   * "Show" datepicker settings
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.dpCfgShow = {
    format: 'dd.MM.yyyy',
    minDate: new Date(),
    changeHandler: function (form, field = null) {
      if (field) {
        form[field].$setTouched()
      } else {
        form.dateFrom.$setTouched()
        form.dateTo.$setTouched()
      }
      const fromDate = vm.show.$fromDate && vm.show.$fromDate.setHours(vm.show.$fromTime.getHours(), vm.show.$fromTime.getMinutes())
      const toDate = vm.show.$toDate && vm.show.$toDate.setHours(vm.show.$toTime.getHours(), vm.show.$toTime.getMinutes())
      const minDateStart = fromDate > formatDateByTimezone(Date.now(), false).valueOf()
      const minDateEnd = toDate > formatDateByTimezone(Date.now(), false).valueOf()
      if (field === 'dateFrom' || !field) {
        form.dateFrom.$setValidity('minDate', minDateStart)
        form.dateFrom.$setValidity('after', true)

        if (fromDate && toDate) {
          const after = toDate > fromDate
          if (vm.show.$toDateUnlimited) {
            form.dateFrom.$setValidity('after', true)
            form.dateTo.$setValidity('earlier', true)
          } else {
            if (form.dateTo.$error && form.dateTo.$error.earlier === true) {
              form.dateTo.$setValidity('earlier', after)
            }
            form.dateFrom.$setValidity('after', after)
          }
        }
      }
      if (field === 'dateTo' || !field) {
        form.dateTo.$setValidity('earlier', true)
        form.dateTo.$setValidity('minDate', true)
        if (!vm.show.$toDateUnlimited) {
          form.dateTo.$setValidity('minDate', minDateEnd)
          if (fromDate && toDate) {
            const earlier = toDate > fromDate
            if (form.dateFrom.$error && form.dateFrom.$error.after === true) {
              form.dateFrom.$setValidity('after', earlier)
            }
            form.dateTo.$setValidity('earlier', earlier)
          }
        } else {
          form.dateFrom.$setValidity('after', true)
          form.dateFrom.$setValidity('earlier', true)
          form.dateTo.$setValidity('after', true)
          form.dateTo.$setValidity('earlier', true)
        }
      }
    }
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.openShowFrom = function () {
    vm.dpCfgShow.fromOpened = true
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.openShowTo = function () {
    vm.dpCfgShow.toOpened = true
  }

  /**
   * "From" datepicker settings
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.dpCfgSeason = {
    format: 'dd.MM.yyyy',
    minDate: new Date(),
    changeHandler: function (form, season, field = null) {
      if (field) {
        form[field].$setTouched()
      } else {
        form.dateSSFrom.$setTouched()
        form.dateSSTo.$setTouched()
      }
      const fromDate = season.$fromDate && season.$fromDate.setHours(season.$fromTime.getHours(), season.$fromTime.getMinutes())
      const toDate = season.$toDate && season.$toDate.setHours(season.$toTime.getHours(), season.$toTime.getMinutes())
      const minDateStart = fromDate > formatDateByTimezone(Date.now(), false).valueOf()
      const minDateEnd = toDate > formatDateByTimezone(Date.now(), false).valueOf()
      if (field === 'dateSSFrom' || !field) {
        form.dateSSFrom.$setValidity('minDate', minDateStart)
        form.dateSSFrom.$setValidity('after', true)

        if (fromDate && toDate) {
          const after = toDate > fromDate
          if (season.$toDateUnlimited) {
            form.dateSSFrom.$setValidity('after', true)
            form.dateSSTo.$setValidity('earlier', true)
          } else {
            if (form.dateSSTo.$error && form.dateSSTo.$error.earlier === true) {
              form.dateSSTo.$setValidity('earlier', after)
            }
            form.dateSSFrom.$setValidity('after', after)
          }
        }
      }
      if (field === 'dateSSTo' || !field) {
        form.dateSSTo.$setValidity('earlier', true)
        form.dateSSTo.$setValidity('minDate', true)
        if (!season.$toDateUnlimited) {
          form.dateSSTo.$setValidity('minDate', minDateEnd)
          if (fromDate && toDate) {
            const earlier = toDate > fromDate
            if (form.dateSSFrom.$error && form.dateSSFrom.$error.after === true) {
              form.dateSSFrom.$setValidity('after', earlier)
            }
            form.dateSSTo.$setValidity('earlier', earlier)
          }
        } else {
          form.dateSSFrom.$setValidity('after', true)
          form.dateSSFrom.$setValidity('earlier', true)
          form.dateSSTo.$setValidity('after', true)
          form.dateSSTo.$setValidity('earlier', true)
        }
      }
    }
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.openSSFrom = function () {
    vm.dpCfgSeason.fromOpened = true
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.openSSTo = function () {
    vm.dpCfgSeason.toOpened = true
  }

  vm.stbUrlAttention = function (url) {
    const webPlatform = vm.platformTypes.find(p => p.name === 'WEB')
    let webPlatformChecked = false
    if (webPlatform) {
      webPlatformChecked = webPlatform.checked
    }
    if (webPlatformChecked) {
      return false
    } else {
      return vm.urlAttention(url)
    }
  }

  vm.urlAttention = function (url) {
    if (url) {
      return url.slice(0, 7) === 'http://'
    } else {
      return false
    }
  }

  /**
   * Handle add tag to Show-model
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.addTag = (item) => {
    const { LIMIT } = TAG_CUSTOM_ERROR_TYPES
    if (vm.show.tags.find(tag => tag.name === item.name)) { // condition for unique
      alertLiteSvc.alertError('Tag should be unique within the TV Show')
    } else {
      vm.show.tags.push({ name: item.name })
    }
    if (vm.show.tags.length > 10) {
      ~vm.tagErrors.indexOf(LIMIT) > -1 && vm.tagErrors.push(LIMIT)
    }
  }

  vm.createTag = function (select) {
    vm.addTag({ name: select.search })
    vm.currentTag = { search: '' }
    select.open = false
  }

  vm.changeTag = function (search) {
    vm.currentTag = { search }
    const { COMMA, WORD, LENGTH } = TAG_CUSTOM_ERROR_TYPES

    if (search.includes(' ')) {
      if (!vm.tagErrors.length) {
        ~vm.tagErrors.indexOf(WORD) > -1 && vm.tagErrors.push(WORD)
      }
      return
    }
    if (search.includes(',')) {
      if (!vm.tagErrors.length) {
        ~vm.tagErrors.indexOf(COMMA) > -1 && vm.tagErrors.push(COMMA)
      }
      return
    }
    if (search.length > 15) {
      if (!vm.tagErrors.length) {
        ~vm.tagErrors.indexOf(LENGTH) > -1 && vm.tagErrors.push(LENGTH)
      }
      return
    }
    vm.tagErrors = vm.tagErrors.filter(tag => ![LENGTH, COMMA, WORD].includes(tag))
  }

  vm.hasntSearchTag = function () {
    if (vm.currentTag.search.length > 0) {
      if (!vm.tags) {
        return true
      }
      return !vm.tags.find(tag => tag.name === vm.currentTag.search) && !vm.show.tags.find(tag => tag.name === vm.currentTag.search)
    }
    return false
  }

  /**
   * Handle remove tag from Show-model
   *
   * @memberof mwApp/shows.controller:AddShowCtrl
   */
  vm.removeTag = (tag) => {
    const { LIMIT } = TAG_CUSTOM_ERROR_TYPES
    vm.show.tags.splice(vm.show.tags.findIndex(t => t.name === tag.name), 1)
    if (vm.show.tags.length <= 10) { // condition for limit
      vm.tagErrors.splice(vm.tagErrors.indexOf(LIMIT), 1)
    }
  }

  /**
   * Search content params with default values
   *
   * @memberof mwApp/show.controller:AddShowCtrl
   * @type {Object}
   */
  vm.searchTagsParams = {
    search: '',
    page: 0,
    last: false
  }

  /**
   * Filter content, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/show.controller:AddShowCtrl
   * @param  {Object} $select
   */
  vm.$timerTags = 0
  vm.openCountTags = 0
  vm.refreshTags = function ($select = {}) {
    let search = $select.search || ''

    vm.searchTagsParams.page = 0

    search = search ? search.toLowerCase() : ''
    vm.openCountTags = $select.open
      ? vm.openCountTags + 1
      : 0

    if ($select.open) {
      window.clearTimeout(vm.$timerTags)
      if (authSvc.hasAccess('viewChannel')) {
        vm.$timerTags = window.setTimeout(() => {
          Show.search(
            'api/tags',
            {
              search,
              page: 0,
              count: 25
            }
          )
            .then((result) => {
              vm.searchTagsParams.last = result.last
              vm.tags = result.content
            })
        }, 700)
      }
    }
  }

  if (authSvc.hasAccess('viewChannel')) {
    Show.search(
      'api/tags',
      {
        search: '',
        page: 0,
        count: 25
      }
    )
      .then((result) => {
        vm.searchTagsParams.last = result.last
        vm.tags = result.content
      })
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   */
  vm.$timerTagsScroll = 0
  vm.tagsCallbackScroll = (event) => {
    const { page, last, search } = vm.searchTagsParams
    if (!last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerTagsScroll)
      if (authSvc.hasAccess('viewChannel')) {
        vm.$timerTagsScroll = window.setTimeout(() => {
          Show.search(
            'api/tags',
            { search, page: page + 1, count: 25 }
          )
            .then((result) => {
              vm.searchTagsParams.last = result.last
              vm.tags = vm.tags.concat(result.content)
              vm.searchTagsParams.page = result.number
            })
        }, 700)
      }
    }
  }

  /**
   *  Filter networkSets according available networks
   * @param pckg
   * @param form
   * @returns {Function}
   */
  vm.deselectPckg = function (pckg, form) {
    form.$setDirty()
    vm.deselectNetwork(pckg)
    if (vm.show.networks.length > 0) {
      vm.show.contentSets = vm.show.contentSets.filter(cs => cs.networkId !== pckg.id)
      vm.seasons.forEach(s => {
        s.contentSets = s.contentSets.filter(cs => cs.networkId !== pckg.id)
      })
    } else {
      vm.networkSelected = null
    }
    vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.networks.filter(n => n.id !== 0).sort((a, b) => {
      return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
    }))
    vm.networks = vm.networks.filter(n => n.id !== -1)
  }

  vm.selectOrganization = function () {
    if (vm.networkSelected.id === 0) {
      vm.networks = [{ id: -1, name: 'Deselect all Organization' }]
      vm.show.networks = angular.copy(vm.listOfNetworks)
    } else if (vm.networkSelected.id === -1) {
      vm.show.networks = []
      vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.listOfNetworks)
      vm.networkSelected = null
    } else {
      vm.selectNetwork(vm.networkSelected)
      if (vm.networks.length === 1) {
        vm.networks = [{ id: -1, name: 'Deselect all Organization' }]
      }
    }
  }

  vm.showAllNetworks = false
  vm.showButton = function () {
    const container = document.getElementById('networks-container')
    return container.scrollHeight > 210
  }

  vm.changeDisplayNumber = function () {
    setTimeout(() => {
      if (vm.seasons.some(s => isNaN(+s.displayNumber))) {
        vm.seasons.sort((a, b) => {
          if (a.displayNumber < b.displayNumber) {
            return -1
          }
          return 1
        })
      } else {
        vm.seasons.sort((a, b) => {
          if (+a.displayNumber < +b.displayNumber) {
            return -1
          }
          return 1
        })
      }
      vm.seasons.forEach((s, index) => {
        s.sortOrder = index
      })
    }, 0)
  }

  vm.toggleShowAllNetworks = function () {
    vm.showAllNetworks = !vm.showAllNetworks
  }
  /**
   * table state
   *
   * @type {Object}
   */
  vm.tableState = {
    page: 0,
    count: 25,
    name: '',
    last: false
  }

  /**
   * Add content set handler
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * * @param season
   */
  vm.addSeasonContentSet = function (season) {
    season.contentSets.push({ })
  }

  /**
   * Delete content set item
   *
   * @memberof mwApp/packages.controller:AddShowCtrl
   * @param season
   * @param index
   * @param form
   */
  vm.deleteSeasonContentSet = function (season, index, form) {
    form.$setDirty()
    season.contentSets.splice(index, 1)
  }

  /**
   * Load sets by network and store it
   *
   * @memberof mwApp/packages.controller:AddShowCtrl
   * @param ns
   */
  vm.changeNetworkSets = function (ns) {
    ns.showSet = null

    ShowSet.loadShowSets(vm.tableState, { networkId: ns.network.id })
      .then((result) => {
        ns.sets = result.content
        vm.tableState.last = result.last
      })
  }

  /**
   * Filter sets, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   * @param  {Object} $select
   * @param  {Object} ns
   */
  vm.refreshSets = function ($select = {}, ns) {
    const search = $select.search || null
    vm.tableState.page = 0
    vm.tableState.number = 25

    vm.openCount = $select.open ? ns.openCount + 1 : 0

    if (vm.openCount >= 1 && search) {
      vm.tableState.name = search
    }

    /*
      if (vm.openCount === 1) {
        $select.search = vm.tableState.name
      } */

    if ($select.open) {
      window.clearTimeout(vm.$timer)
      vm.$timer = window.setTimeout(() => {
        ShowSet.loadShowSets(vm.tableState, { networkId: ns.network.id })
          .then((result) => {
            ns.sets = result.content
            vm.tableState.last = result.last
          })
      }, 700)
    }
  }

  /**
   * Handler for scroll event of sets select list
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @param event
   */
  vm.$timerScroll = 0
  vm.setsCallbackScroll = (event, ns) => {
    const { page, last } = vm.tableState
    if (!last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerScroll)
      vm.$timerScroll = window.setTimeout(() => {
        ShowSet.loadShowSets({ ...vm.tableState, page: page + 1 }, { networkId: vm.pckg.id })
          .then((result) => {
            ns.sets = result.content
            vm.tableState.last = result.last
            vm.tableState.page = result.page
          })
      }, 700)
    }
  }

  vm.onNewEpisodePositionClick = function (position) {
    vm.newEpisodePositionDisabled = true
    const url = 'api/episodes/position'
    const params = {
      tvShowId: vm.show.id,
      position
    }

    if (vm.activeTab) {
      params.seasonId = vm.activeTab
    }

    $http.patch(url, params)
      .then(() => {})
      .finally(() => { vm.newEpisodePositionDisabled = false })
  }

  vm.openSortEpisodes = function () {
    $uibModal.open({
      templateUrl: 'components/shows/views/sortEpisodes.html',
      controller: 'SortEpisodesCtrl as vm',
      animation: false,
      size: 'xl',
      resolve: {
        episodes: function () {
          return vm.episodes
        },
        tvShowId: function () {
          return vm.show.id
        },
        seasonId: function () {
          return vm.activeTab
        }
      }
    })
      .result
      .then(
        function close () {
          if (vm.activeTab) {
            vm.getSeasonEpisodes()
          } else {
            vm.getEpisodes()
          }
        },
        function dismiss () {
        })
  }

  $scope.$watch('vm.show.networks.length', (cur, old) => {
    if (+cur === 1 && +old === 0) {
      vm.show.contentSets = vm.show.contentSets.filter(cs => cs.networkId === vm.show.networks[0].id)
      vm.seasons.forEach(s => {
        s.contentSets = s.contentSets.filter(cs => cs.networkId === vm.show.networks[0].id)
      })
    }
  })

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/packages.controller:AddShowCtrl
   */
  $scope.$on('$viewContentLoaded', function () {
    vm.location.setGoBackLink(vm.show._publicListUrl)
  })

  $timeout(vm.unsetDisable)
}
